module.exports = __webpack_public_path__ + "static/media/3 03 Tulleord Na er det din tur.1cdd25c9.mp3";